import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import { APP_CONFIG } from '@/config';
import { wxService } from '@/services/wx.service';
import store from '@/store';
import { utilsService } from '@/services/utils.service';
import { lsService } from '@/services/ls.service';
import { tap } from 'rxjs/operators';
import { pcService } from '@/services/pc.service';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  { path: '/', redirect: '/boss' },
  { path: '/home', name: 'Home', component: Home },
  { path: '/maze', name: 'Maze', component: () => import(/* webpackChunkName: "rr" */ '../views/Maze.vue'), meta: { progressCheck: 1 } },
  { path: '/cube', name: 'Cube', component: () => import(/* webpackChunkName: "rr" */ '../views/Cube.vue'), meta: { progressCheck: 2 } },
  { path: '/graphical', name: 'Graphical', component: () => import(/* webpackChunkName: "rr" */ '../views/Graphical.vue'), meta: { progressCheck: 3 } },
  { path: '/entrance', name: 'Entrance', component: () => import(/* webpackChunkName: "rr" */ '../views/Entrance.vue'), meta: { progressCheck: 3 } },

  { path: '/sudoku', name: 'Sudoku', component: () => import(/* webpackChunkName: "rr" */ '../views/Sudoku.vue'), meta: { progressCheck: 4 } },
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // { path: '/about', name: 'About', component: () => import(/* webpackChunkName: "rr" */ '../views/About.vue') },

  { path: '/crypto', name: 'DayBook', component: () => import(/* webpackChunkName: "rr" */ '../views/DayBook.vue'), meta: { progressCheck: 5 } },
  { path: '/boss', name: 'Boss', component: () => import(/* webpackChunkName: "rr" */ '../views/Boss.vue') },
  // { path: '/film', name: 'Film', component: () => import(/* webpackChunkName: "rr" */ '../views/Film.vue') },
  // { path: '/intro', name: 'Intro', component: () => import(/* webpackChunkName: "rr" */ '../views/Intro.vue') },
  { path: '/kvDetail/:kv', name: 'KvDetail', component: () => import(/* webpackChunkName: "rr" */ '../views/KvDetail.vue') },
  { path: '/missionEnd/:mission', name: 'MissionEnd', component: () => import(/* webpackChunkName: "rr" */ '../views/MissionEnd.vue') },
  { path: '/missionStart/:mission', name: 'MissionStart', component: () => import(/* webpackChunkName: "rr" */ '../views/MissionStart.vue') },
  { path: '/end', name: 'End', component: () => import(/* webpackChunkName: "rr" */ '../views/End.vue'), meta: { progressCheck: 6 } },
  { path: '/form', name: 'Form', component: () => import(/* webpackChunkName: "rr" */ '../views/Form.vue') },
  { path: '/prize', name: 'Prize', component: () => import(/* webpackChunkName: "rr" */ '../views/Prize.vue') },
  { path: '/winlist', name: 'Winlist', component: () => import(/* webpackChunkName: "rr" */ '../views/WinList.vue') },
];

const router = new VueRouter({
  routes,
});

router.afterEach((to, from) => {
  const data = {
    ftitle: '劳斯莱斯攻氪行动',
    ttitle: '劳斯莱斯攻氪行动',
    fdesc: '共解宇宙奥秘',
    imgUrl: `${APP_CONFIG.shareLink}${require('@/assets/images/shareImg.jpg')}`,
    link: `${APP_CONFIG.shareLink}index.html`,
    tsuccess: () => {},
    success: () => {},
  };
  console.log(`updated wx share`);

  wxService.share(data);
});

router.beforeEach((to, from, next) => {
  lsService
    .getUserData()
    .pipe(
      tap(res => {
        console.log('getUserData', res);
        // pcService.gameProgress(res);

        const gameProgress = pcService.gameProgress(res);
        let goHome = false;

        console.log({ gameProgress }, to.meta.progressCheck);

        // router 里有明确progressCheck的
        if (to.meta && to.meta.progressCheck) {
          if (gameProgress < to.meta.progressCheck) goHome = true;
        }

        // kv小锁的
        if (to.name == 'KvDetail' && to.params.kv && to.params.kv == `2`) {
          if (gameProgress == 1) goHome = true;
        }

        // 章节结束页
        if (to.name == 'MissionEnd' && to.params.mission) {
          const data = {
            '1': 3,
            '2': 5,
            '3': 6,
          };
          if (data[to.params.mission] && gameProgress < data[to.params.mission]) goHome = true;
        }

        if (goHome) {
          console.error({ to, from, gameProgress });
          next({ path: '/home', replace: true });
          return;
        }

        next();
      }),
    )
    .subscribe();
});

export default router;
